import { Tabs } from './Tabs';
import register from './register';

register(Tabs);
